import { queryOptions, skipToken } from '@tanstack/react-query'
import { keys } from './keys'
import {
  fetchCurrentAdminRbacPermissions,
  fetchRbacRole,
  fetchRbacRoles,
  fetchRbacRolesWithoutHolder,
} from './rbac.queries'

export const getRbacRolesOptions = () =>
  queryOptions({
    queryKey: keys.rbac.roles.list(),
    queryFn: fetchRbacRoles,
  })

export const getRbacRolesWithoutHolderOptions = () =>
  queryOptions({
    queryKey: keys.rbac.roles.withoutHolder(),
    queryFn: fetchRbacRolesWithoutHolder,
  })

export const getCurrentAdminRbacPermissionsOptions = () =>
  queryOptions({
    queryKey: keys.rbac.permissions.current(),
    queryFn: fetchCurrentAdminRbacPermissions,
  })

export const getRbacRoleOptions = (roleId: number | undefined) =>
  queryOptions({
    queryKey: keys.rbac.roles.byId(roleId),
    queryFn: roleId !== undefined ? () => fetchRbacRole(roleId) : skipToken,
  })
